import React, { useEffect, useRef, useState } from 'react';
import {
  EXTENSION_HEALTH_CHECK,
  EXTENSION_HEALTH_CHECK_RESPONSE,
  EXTENSION_HEALTH_CHECK_TIMEOUT
} from '../../common/constants';

export interface State {
  loading: boolean;
  isInstalled: boolean;
}

const context = React.createContext<State>({
  loading: true,
  isInstalled: false
});

export const ExtensionInstalledProvider: React.FC = ({ children }) => {
  const [state, setState] = useState<State>({
    loading: true,
    isInstalled: false
  });
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const onMessage = (e: MessageEvent) => {
    if (e.data.message !== EXTENSION_HEALTH_CHECK_RESPONSE) {
      return;
    }
    setState({
      loading: false,
      isInstalled: true
    });
    if (timeoutRef.current !== null) {
      clearTimeout(timeoutRef.current);
    }
    window.removeEventListener('message', onMessage);
  };

  useEffect(() => {
    timeoutRef.current = setTimeout(() => {
      setState({
        loading: false,
        isInstalled: false
      });
      window.removeEventListener('message', onMessage);
    }, EXTENSION_HEALTH_CHECK_TIMEOUT);
    window.addEventListener('message', onMessage);
    window.postMessage(
      {
        message: EXTENSION_HEALTH_CHECK
      },
      '*'
    );

    return () => window.removeEventListener('message', onMessage);
  }, []);
  return <context.Provider value={state}>{children}</context.Provider>;
};

export const useExtensionInstalled = (): State => {
  return React.useContext(context);
};
